<auth-page-layout title="Welcome to the {{agency?.name}} Patient Portal"
  [logoUrl]="agency?.logoUrl"
  cardTitle="Create Account" illustration="assets/illustration-sign-in.png">
  <form>
    <div class="form-group">
      <p class="mb-0">Name</p>
      <p class="mb-0">{{user?.firstName}} {{user?.lastName}}</p>
    </div>
    <div class="form-group">
      <p class="mb-0">Email</p>
      <p class="mb-0">{{user?.email}}</p>
    </div>
    <div class="form-group">
      <label for="password">Password</label>
      <input id="password" name="password" type="password" [(ngModel)]="password1" (keyup)="checkConfirm()"
        class="form-control" aria-describedby="emailHelp" placeholder="Enter password">
      <small id="passwordHelp" class="form-text text-muted">At least 10 characters including uppercase, lowercase,
        and a number</small>
    </div>
    <div class="form-group">
      <label for="confirm-password">Confirm Password</label>
      <input id="confirm-password" name="confirm-password" type="password" [(ngModel)]="password2"
        (keyup)="checkConfirm($event)" class="form-control" aria-describedby="emailHelp" placeholder="Repeat password">
      <small id="passwordMessage" class="form-text text-danger">{{passwordMessage}}</small>
    </div>

    <button (click)="confirmAccount()" [disabled]="!confirmAllowed" type="button"
      class="btn btn-primary btn-block">Create Account</button>
  </form>
</auth-page-layout>
